import { type FunctionComponent, lazy, Suspense } from "react";

import { Spinner } from "@app/components/spinners/spinner";

const ImporterCuratePageReviewAssortment = lazy(() => {
  return new Promise<{ default: FunctionComponent }>((resolve, reject) => {
    import("curate/lib")
      .then((lib) => {
        resolve({
          default: () => <lib.default.ReviewAssortmentPage />,
        });
      })
      .catch(reject);
  });
});

export const LazyCuratePageReviewAssortment = () => {
  return (
    <Suspense fallback={<Spinner height={"100vh"} />}>
      <ImporterCuratePageReviewAssortment />
    </Suspense>
  );
};
